import { useSelector } from "react-redux";

export const useGetDashboard = () => {
  const dashboard = useSelector(({ dashboard }) => dashboard);

  return {
    dashboard,
  };
};
